<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-08-05 17:43:06
 * @LastEditTime: 2022-01-17 23:16:39
 * @Description:
-->
<template>
    <div class="top-menu">
        <div
            @click="togleMenu(menu)"
            :class="
                menu.code === currentValue
                    ? 'top-menu-item selected'
                    : 'top-menu-item'
            "
            v-for="menu in menuData"
            :key="menu.code"
        >
            {{ menu.name }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../store/index'
import { MDLogMenu } from '@/api/menu'
export default {
    name: 'topMenu',
    props: {},
    data() {
        return {
            currentValue: '',
            // menuData: [
            //     {
            //         name: '工作台',
            //         id: 1,
            //     },
            //     {
            //         name: '职能权限',
            //         id: 2,
            //     },
            //     {
            //         name: '流程中心',
            //         id: 3,
            //     },
            //     {
            //         name: '供应链',
            //         id: 4,
            //     },
            //     {
            //         name: '商品',
            //         id: 5,
            //     },
            //     {
            //         name: '样机',
            //         id: 6,
            //     },
            // ],
        }
    },
    // created() {
    //     this.MDLogMenu = MDLogMenu
    // },
    computed: {
        ...mapGetters({
            menuData: 'menuData',
            selectedMenu: 'selectedMenu',
            microData: 'microData',
        }),
    },
    methods: {
        togleMenu(item) {
            console.log(item)
            console.log(window)
            MDLogMenu(
                { resourceType: 1 },
                'JDmall_md',
                'menu_md',
                item.code,
                item.name,
                null
            )
            this.currentValue = item.code
            store.dispatch('app/setSubMenu', item.childrenMenuList)
            store.dispatch('app/setSelectedMenu', item)
            console.log(this.microData)
            console.log(item.childrenMenuList)
            if (item.childrenMenuList.length) {
                this.microData.forEach((micro, index) => {
                    if (micro.id === item.childrenMenuList[0].code) {
                        console.log(micro)
                        this.$store.dispatch('app/setSelectedSubMenu', micro)
                        window.clickUrl = micro.activeLinkUrl
                        history.pushState(
                            null,
                            `${micro.activeLinkUrl}`,
                            `${micro.activeLinkUrl}`
                        )
                    }
                })
            }
        },
    },
    watch: {
        selectedMenu(val) {
            this.currentValue = val.code
        },
    },
}
</script>

<style lang="scss" scoped>
.top-menu {
    flex: 1;
    display: flex;
    align-items: center;
    &-item {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        margin-left: 32px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
    }
    .selected {
        font-weight: 500;
        &::after {
            content: '';
            left: 6px;
            right: 6px;
            bottom: 3px;
            position: absolute;
            height: 3px;
            background: rgba(255, 255, 255, 1);
            border-radius: 2px;
        }
    }
}
</style>
